<template>
	<sf-button icon="square-plus" v-if="isButton_(scrId, 'AD')" :onClick="openModal">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/GuideBoard/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		openModal() {
			this.GuideBoardModalValue.flg = 'I';
			this.defaultAssign_({ key: 'GuideBoardModal', value: true });
		}
	}
};
</script>
<style></style>
